import type { Router } from 'vue-router'
import useWebsite from '@/composables/website'
import { setRouteEmitter } from '@/utils/route-listener'

export default function setPageTitleGuard(router: Router) {
  router.beforeEach((to) => {
    setRouteEmitter(to)
    const { setPageTitle } = useWebsite()
    setPageTitle(to)
  })
}
